// add . every 3 digits
export const formatTick = t => t.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')

// shorten public address to be more readable
export const shortenAddress = (address, offset = 3) => {
  return address.slice(0, offset) + '...' + address.slice(-(offset))
}

// format qubic billions with ' separated thousands
export const formatQubic = q => q.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")